module.exports = __webpack_public_path__ + "img/text.3e7289a2.jpg";